<template>
  <form
    id="journey-form"
    ref="journey-form"
    class="tw-max-w-full tw-flex-shrink-0 tw-mx-auto tw-mb-20 auth-card tw-flex tw-flex-wrap"
    method="post"
    action="/journey/create"
    @submit.prevent="onSubmit"
  >
    <div class="tw-w-full tw-mb-4">
      <h1 class="tw-text-4xl font-title">{{ journeyId ? 'Edit Journey' : 'Create a Journey' }}</h1>
      <!-- <h6 class="tw-text-base opacity-78 tw-text-app-deep-blue">Please fill all inputs</h6> -->
    </div>

    <div class="tw-w-full tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <InputGroup
        :class="{ '--loading-data': loadingForm }"
        label="Name"
        name="name"
        type="text"
        placeholder="name"
        input-classes="tw-p-3"
        input-type=""
        v-model="form.title"
        :error="errors.title"
      />
    </div>
    <div class="tw-w-full tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <QuillTextareaGroup
        :class="{ '--loading-data': loadingForm }"
        label="Description"
        instruct="Give a small description about the goal"
        name="description"
        type="text"
        placeholder="description"
        input-classes="tw-p-3 focus:tw-bg-gray-100"
        v-model="form.description"
        :rows="4"
        :error="errors.description"
      />
    </div>

    <div class="tw-w-full tw-flex-shrink-0 tw-px-1 tw-mb-4 tw-pt-10 tw-flex tw-justify-between">
      <div>
        <BaseButton
          type="submit"
          :class="[
            'tw-block tw-w-full md:tw-inline-block md:tw-w-auto tw-mb-4 tw-py-3 tw-px-8',
            `${btnClass}`
          ]"
          :text="btnText"
          :disabled="!canSubmit || btnDisabled"
        />
      </div>

      <!-- <div v-if="journeyId">
        <BaseButton
          class="tw-bg-red-100 opacity-54 hover:tw-opacity-100 tw-border-red-600 tw-text-red-600 tw-inline-block tw-mb-4 tw-py-3 transition-fast"
          text="Delete"
          confirm
          @click="deleteGoal()"
        />
      </div> -->
    </div>

  </form>
</template>

<script>
import _debounce from 'lodash/debounce';

import QuillTextareaGroup from '@/components/QuillTextareaGroup.vue';
import InputGroup from '@/components/InputGroup.vue';

import form from '@/modules/formHelper';

export default {
  name: 'EditJourney',
  components: {
    QuillTextareaGroup,
    InputGroup,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    companyProgram: {
      type: Object,
      required: false,
    },
    journeyId: {
      type: [String, Number],
      default: undefined,
    },
    btnClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loadingForm: true,
      errorForm: undefined,
      btnText: 'Save',
      btnDisabled: false,
      pillarGroups: [],
      errors: {},
      form: {
        title: undefined,
        description: undefined,
      },
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'company.id': function () {
      this.resetForm();
      this.loadForm();
    },
    // eslint-disable-next-line func-names
    'companyProgram.id': function () {
      this.resetForm();
      this.loadForm();
    },
    journeyId() {
      this.resetForm();
      this.loadForm();
    },
  },
  computed: {
    canSubmit() {
      return form.isValidTextInput(this.form.title)
        && !this.loadingForm
        && form.isValidTextInput(this.form.description);
    },
  },
  methods: {
    resetForm() {
      this.form = {
        name: undefined,
        description: undefined,
      };
    },
    // eslint-disable-next-line func-names
    loadForm: _debounce(async function () {
      this.loadingForm = true;
      this.errorForm = undefined;

      // * get goal details if id is defined
      if (this.journeyId !== undefined) {
        const journeys = (await this.$store.dispatch('getProgramJourneys', [this.company.id, this.companyProgram.id, false]) || []);
        const curr = journeys.find((g) => Number(g.id) === Number(this.journeyId)) || {};

        this.form.title = curr.title || '';
        this.form.description = curr.description || '';
      }

      await this.$nextTick();
      await this.$nextTick();

      this.loadingForm = false;
    }, 300),
    async onSubmit() {
      if (!this.canSubmit) {
        this.$toasted.global.appError({
          errorMessage: 'You can\'t submit the form. Check for empty inputs',
        });

        console.warn('Cannot submit form... \n check for empty inputs');
        return false;
      }

      this.btnDisabled = true;
      this.btnText = 'working...';

      const data = {
        ...(this.form),
        companyId: this.company.id,
        programId: this.companyProgram.id,
        journeyId: this.journeyId,
      };

      const result = await this.$store.dispatch('saveProgramJourney', data);

      if (result) {
        this.$toasted.success('Saved!', { duration: 1000 });
        this.$emit('created-success');

        // TODO: LOG ACTIONS
        // if (this.journeyId) {
        //   this.$store.dispatch('logAction', this.$store.state.Logger.actionsIndexes.editGoal);
        // } else {
        //   this.$store.dispatch('logAction', this.$store.state.Logger.actionsIndexes.addGoal);
        // }
      } else {
        this.$toasted.global.appError({
          errorMessage: 'Saving Journey failed. Please try again later',
        });
      }

      this.btnDisabled = false;
      this.btnText = 'save';

      return result;
    },
  },
  async created() {
    this.errors = { ...this.form };

    await this.$nextTick();
    await this.loadForm();
    await this.$nextTick();

    this.loadingForm = false;
  },
};
</script>

<style>

</style>
